export const findIcon = (key) => {
  const iconMap = {
    deviceMobile: ['mobile', 'phone', 'unset'],
    deviceTabletPortrait: ['tabletS'],
    deviceTabletLandscape: ['tabletM', 'tabletL'],
    deviceSmallScreen: ['screenS', 'screenM'],
    deviceBigScreen: ['screenL', 'tv'],
    columnsOutline: ['canvas'],
    layoutOutline: ['custom']
  }
  let icon = null
  const keys = Object.keys(iconMap)
  Object.values(iconMap).forEach((device, index) => {
    const isInArray = device.includes(key)
    if (isInArray) {
      icon = keys[index]
    } else {
      device.forEach((deviceKey) => {
        if (key.includes(deviceKey)) {
          icon = keys[index]
        }
      })
    }
  })
  return `${icon}Outline`
}

export function getProjectIcon() {
  const state = this.getRootState()
  if (state.icon?.src) {
    return state.icon?.src
  }
  return null
}
